import React from 'react';
import { getFacebookUserProfile, confirmFacebookUser } from '../../api/oauthApi';
import { OAuthConfirmationPage } from '../../components/OAuthConfirmation';

const facebookProviderConfig = {
    testIdPrefix: 'facebook-confirmation.page',
    getUserProfile: getFacebookUserProfile,
    confirmUser: confirmFacebookUser,
    idFieldName: 'facebookId',
    testIds: {
        guardianSpan: 'auth.facebook.span-247',
        playerDetailsImg: 'auth.facebook.img-253',
        dobImg: 'auth.facebook.img-344',
        location: 'facebookauthconfirmationpage.location-location',
        parentsNotice: 'auth.facebook.div-400',
    },
};

const FacebookAuthConfirmationPage = () => (
    <OAuthConfirmationPage providerConfig={facebookProviderConfig} />
);

export default FacebookAuthConfirmationPage;
